import { Text, Field, useSitecoreContext, getFieldValue, Item } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';
import withValidDatasourceCheck from 'lib/enhancers/withValidDatasourceCheck';

import { ComponentProps } from 'lib/component-props';
import compose from 'lib/enhancers/compose';
import withStyles from 'lib/enhancers/withStyles';

import styles from './FAQ.module.scss';
import FaqItem, { FaqItemProps } from './FaqItem';
import { RecordOfFields } from 'models/fields';

const cx = classNames.bind(styles);

type FaqSectionFields = {
  children: FaqItemProps[];
  faqItemHeadingLevel: Field<string>;
  faqItemHeadingStyle: Item | null;
  title: Field<string>;
  titleHeadingLevel: Field<string>;
  titleHeadingStyle: Item | null;
};

type FaqSectionProps = ComponentProps & {
  fields: FaqSectionFields;
};

const FaqSection = (props: FaqSectionProps): React.JSX.Element => {
  const { className, fields } = props;
  const { title, titleHeadingLevel, faqItemHeadingLevel } = fields;
  const { sitecoreContext } = useSitecoreContext();

  const titleHeadingStyleItemField = fields.titleHeadingStyle?.fields as RecordOfFields;
  const titleHeadingStyleValue = getFieldValue<string>(titleHeadingStyleItemField, 'Value') || 'font-style-lg';

  const faqHeadingStyleItemField = fields.faqItemHeadingStyle?.fields as RecordOfFields;
  const faqHeadingStyleValue = getFieldValue<string>(faqHeadingStyleItemField, 'Value') || 'font-style-md';

  return (
    <div className={cx('faq-section', className)}>
      <Text
        className={cx('header', cx(titleHeadingStyleValue))}
        field={title}
        tag={titleHeadingLevel?.value || 'h2'}
        encode={sitecoreContext.pageEditing}
      />
      {fields.children?.map((childProps: FaqItemProps) => (
        <FaqItem
          {...childProps}
          headingLevel={faqItemHeadingLevel?.value || 'h3'}
          headingStyle={faqHeadingStyleValue}
          key={childProps.id}
        />
      ))}
    </div>
  );
};

export default compose<FaqSectionProps>(withValidDatasourceCheck(), withStyles())(FaqSection);
